export default __webpack_public_path__ + "static/media/csv.1c401402.png";